module.exports = __webpack_public_path__ + "static/media/FOLHA.911e1902.png";